import React from "react";

export default function MobileSidebarItem({ item, onClick }) {
  return (
    <a href={item.path || "#"} className="sidebar-item" onClick={onClick}>
      {item.icon && <span className="icon-wrapper">{<item.icon />}</span>}
      <span>{item.title}</span>
    </a>
  );
}
